import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Button, ButtonBase, Popper, Typography, useMediaQuery } from '@mui/material';

// project imports
import FundPage from 'views/pages/Fund';
import FormDialog from 'views/utilities/FormDialog';

// assets
import { IconPlus } from '@tabler/icons';

// ==============================|| ADDFUND ||============================== //

const AddFundSection = ({ title }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(false);
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
        if (open) {
            navigate('social');
            navigate('dashboard');
        }
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 3,
                    [theme.breakpoints.down('md')]: {
                        mr: 2
                    }
                }}
            >
                <ButtonBase sx={{ borderRadius: '12px' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&[aria-controls="menu-list-grow"],&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            },
                            width: title ? 'auto' : '34px',
                            padding: title ? 2 : 0
                        }}
                        ref={anchorRef}
                        onClick={handleToggle}
                        color="inherit"
                    >
                        <IconPlus stroke={1.5} size="1.3rem" />
                        {title && (
                            <Typography
                                component={'span'}
                                variant="subtitle1"
                                sx={{
                                    color: theme.palette.grey[700],
                                    mt: 0.5
                                }}
                            >
                                <strong> {title}</strong>
                            </Typography>
                        )}
                    </Avatar>
                </ButtonBase>
            </Box>
            <Popper
                placement={matchesXs ? 'bottom' : 'bottom-end'}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [matchesXs ? 5 : 0, 20]
                            }
                        }
                    ]
                }}
            ></Popper>
            {open && (
                <FormDialog onClose={handleToggle}>
                    <FundPage onClose={handleToggle} />
                </FormDialog>
            )}
        </>
    );
};

AddFundSection.propTypes = {
    title: PropTypes.string
};

export default AddFundSection;
